import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../layouts';
import { CONSTANTS } from '../utils';
import { PATHS } from '../utils/paths';
import GuestRoute from './GuestRoute';
import PrivateRoute from './PrivateRoute';
import { CircularProgress, Box } from '@mui/material';

// Lazy load pages for better performance
const HomePage = lazy(() => import('../pages').then(module => ({ default: module.HomePage })));
const LoginPage = lazy(() => import('../pages').then(module => ({ default: module.LoginPage })));
const InterventionsPage = lazy(() => import('../pages/Intervention/Intervention'));
const NotificationsPage = lazy(() => import('../pages/Notifications/Notifications'));
const PatrimoniesPage = lazy(() => import('../pages/Patrimonies/Patrimonies'));
const PrestationsPage = lazy(() => import('../pages/Prestations/Prestations'));
const UsersPage = lazy(() => import('../pages/Users/Users'));
const HelpPage = lazy(() => import('../pages/Help/Help'));

const LoadingFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);

export const RoutesList = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path={PATHS.Home}
          element={
            <PrivateRoute roles={[CONSTANTS.GTI_ROLE]}>
              <Layout>
                <HomePage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.weekType}
          element={
            <PrivateRoute roles={[CONSTANTS.GTI_ROLE]}>
              <Layout>
                <HomePage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.Users}
          element={
            <PrivateRoute roles={[CONSTANTS.ADMIN_ROLE, CONSTANTS.DAF_ROLE, CONSTANTS.GTI_ROLE]}>
              <Layout>
                <UsersPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.Prestations}
          element={
            <PrivateRoute roles={[CONSTANTS.ADMIN_ROLE]}>
              <Layout>
                <PrestationsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.notifications}
          element={
            <PrivateRoute roles={[CONSTANTS.ADMIN_ROLE, CONSTANTS.GTI_ROLE]}>
              <Layout>
                <NotificationsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.intervention}
          element={
            <PrivateRoute roles={[CONSTANTS.DAF_ROLE, CONSTANTS.GTI_ROLE]}>
              <Layout>
                <InterventionsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.Patrimonies}
          element={
            <PrivateRoute roles={[CONSTANTS.DAF_ROLE]}>
              <Layout>
                <PatrimoniesPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.Help}
          element={
            <PrivateRoute roles={[CONSTANTS.ADMIN_ROLE, CONSTANTS.DAF_ROLE, CONSTANTS.GTI_ROLE]}>
              <Layout>
                <HelpPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={PATHS.Login}
          element={
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          }
        />
        <Route path="*" element={<Navigate replace to={PATHS.Users} />} />
      </Routes>
    </Suspense>
  );
};
export default RoutesList;
